import React from 'react';
import { getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import CustomFieldValue from '../../../AuditLog/CustomFieldValue';

const { Cell } = Table;

const PathKeyCell = ({ dataKey, rowData, colSettings, ...props }) => (
  <Cell {...props}>
    <CustomFieldValue
      value={getOr('', dataKey, rowData)}
      colSettings={colSettings}
    />
  </Cell>
);

PathKeyCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({}),
  colSettings: PropTypes.shape({}).isRequired
};

PathKeyCell.defaultProps = {
  rowData: null
};

export default PathKeyCell;
